import { getPrefixedVar } from '@private/payment';
import styled from 'styled-components';

import Typography from 'components/Typography';

export const ErrorMessage = styled(Typography).attrs(() => ({
  size: 'xs',
  variant: 'regular',
}))`
  margin-top: 2px;
  min-height: 18px;
  color: ${getPrefixedVar(['components', 'errorMessage', 'text'])};
`;
